import React from 'react';
import { QuestionInsight, CombinedNumeric, CombinedBoolean, CombinedText } from '../insightsTypes';
import { INSIGHT_REGISTRY } from '../insightsRegistry';

interface CategoryOverviewProps {
    questions: QuestionInsight[];
    // Server-computed rollup for this section (single-type, so it matches `questions`).
    combined: CombinedNumeric | CombinedBoolean | CombinedText | null;
}

// Renders the combined overview for whichever type this section holds, via the
// insight registry — no per-type branching here.
const CategoryOverview: React.FC<CategoryOverviewProps> = ({ questions, combined }) => {
    const type = questions[0]?.type;

    if (!type || !combined) {
        return null;
    }

    return <>{INSIGHT_REGISTRY[type].renderOverview(questions, combined)}</>;
};

export default CategoryOverview;
